import category1 from './cerdo-fresco.jpg';
import category2 from './cerdo-iberico.jpg';
import category3 from './congelados.jpg';
import category4 from './cordero-fresco.jpg';
import category5 from './curados.jpg';
import category6 from './quesos.jpg';
import category7 from './hamburguesas-y-picadas.jpg';
import category8 from './huevos.jpg';
import category9 from './pavo.jpg';
import category10 from './elaborados-frescos.jpg';
import category11 from './conejo.jpg';
import category12 from './pollo.jpg';
import category13 from './vacuno-mayor.jpg';
import category14 from './ternera.jpg';
import navidad from './seleccion-navidad.jpg';

export default {
    'Selección de Navidad': navidad,
    'Cerdo Fresco': category1,
    'Cerdo Ibérico': category2,
    'Congelados y preparados': category3,
    'Cordero Fresco': category4,
    'Curados y Cocidos': category5,
    Quesos: category6,
    'Hamburguesas y carnes picadas': category7,
    Huevos: category8,
    'Pavo y Pato': category9,
    'Elaborados Frescos': category10,
    'Conejo y Caza': category11,
    Pollo: category12,
    'Vacuno Mayor Fresco': category13,
    'Ternera Fresca': category14,
};
